module.exports = __webpack_public_path__ + "static/media/download-white.2f3a37a6.svg";